import { render, staticRenderFns } from "./receiveBusiness.vue?vue&type=template&id=a8807b5e&scoped=true&"
import script from "./receiveBusiness.vue?vue&type=script&lang=js&"
export * from "./receiveBusiness.vue?vue&type=script&lang=js&"
import style0 from "./receiveBusiness.vue?vue&type=style&index=0&id=a8807b5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8807b5e",
  null
  
)

export default component.exports